module.exports = "./img/e1202042c8b3d8c1d1cefe4e0f1ef6cc.jpg";